import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import { lime } from '@material-ui/core/colors';
import Modal from '../../components/Modal';
import GreenCard2 from '../../components/GreenCard2';

import { setCarInsurance, setValidPatent } from '../../redux/carInsurance';

import { useFormik } from 'formik';

import './style.scss';

const builInitialValues = () => {
  let carInfo = {
    carPatent: '',
    carChasis: '',
    carMotor: '',
  };
  return carInfo;
};

const useStyles = makeStyles({
  hideStyle: {
    visibility: 'hidden',
  },
  showStyle: {
    visibility: 'visible',
  },
});

export default function AddPatent(props) {
  const { nextWasRequired } = props;
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);


  const onClick = () => {
    setOpen(true);
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  const renderModal = () => {
    return <GreenCard2 closeModal={closeModal} />;
  };

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
  }));

  const initialValues = builInitialValues(userCarInsurance);

  const { values, errors, touched, setFieldValue, handleBlur } = useFormik({
    initialValues,
  });

  useEffect(() => {
    const validationErrors = Object.keys(errors).length > 0;
    const valuesRequired =
      values.carPatent && values.carChasis && values.carMotor && true;

    if (!validationErrors && valuesRequired) {
      dispatch(setValidPatent({ isValidPatent: true }));
    }
    if (validationErrors || !valuesRequired) {
      dispatch(setValidPatent({ isValidPatent: false }));
    }
  }, [values, errors]);

  const hasError = (input, inputValue) =>
    (touched[input] && errors[input]) || (nextWasRequired && inputValue === '');

  const error = 'campo obligatorio';

  function handleChange(e) {
    const key = e.target.name;
    let value = e.target.value;
    setFieldValue(key, value);
    dispatch(setCarInsurance({ [key]: value }));
  }

  return (
    <>
      {open && <Modal>{renderModal()}</Modal>}
      <div className='Form-Container-AddressForm'>
        <form className='col s12'>
          <div className='row'>
            <div className='input-field col s10 l3'>
              <input
                value={values.carPatent}
                id='carPatent'
                name='carPatent'
                type='text'
                className={`validate inputField ${
                  hasError('carPatent', values.carPatent) ? 'error' : ''
                }`}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength='60'
              />
              <span htmlFor='carPatent'>Patente</span>
              <p className='error-text'>
                {hasError('carPatent', values.carPatent) && error}
              </p>
            </div>

            <div className='col s2 l1 icon-help'>
              <div onClick={onClick}>
                <HelpOutlineRoundedIcon style={{ color: lime[600] }} />
              </div>
            </div>

            <div className='input-field col s10 l3'>
              <input
                value={values.carChasis}
                id='carChasis'
                name='carChasis'
                type='text'
                className={`validate inputField ${
                  hasError('carChasis', values.carChasis) ? 'error' : ''
                }`}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength='60'
              />
              <span htmlFor='carChasis'>Chasis</span>
              <p className='error-text'>
                {hasError('carChasis', values.carChasis) && error}
              </p>
            </div>

            <div className='col s2 l1 icon-help'>
              <div onClick={onClick}>
                <HelpOutlineRoundedIcon style={{ color: lime[600] }} />
              </div>
            </div>

            <div className='input-field col s10 l3'>
              <input
                value={values.carMotor}
                id='carMotor'
                name='carMotor'
                type='text'
                className={`validate inputField ${
                  hasError('carMotor', values.carMotor) ? 'error' : ''
                }`}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength='60'
              />
              <span htmlFor='ccarMotor'>Motor</span>
              <p className='error-text'>
                {hasError('carMotor', values.carMotor) && error}
              </p>
            </div>

            <div className='col s2 l1 icon-help'>
              <div onClick={onClick}>
                <HelpOutlineRoundedIcon style={{ color: lime[600] }} />
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
